package de.connect2x.timmy

import de.connect2x.timmy.brandings.aokTheme.timmyThemeModuleAOK
import de.connect2x.timmy.brandings.lifetimeTheme.timmyThemeModuleLifetime
import kotlinx.serialization.KSerializer
import kotlinx.serialization.Serializable
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder
import org.koin.core.module.Module

@Serializable(with = Brand.Serializer::class)
enum class Brand(
    val faviconPath: String,
    val themeModule: () -> Module,
    val appName: String,
) {
    LIFETIME(
        faviconPath = "LT_Favicon_Lightmode.ico",
        themeModule = ::timmyThemeModuleLifetime,
        appName = "Lifetime Professional",
    ),
    AOK(
        faviconPath = "AOK_Favicon_Lightmode.ico",
        themeModule = ::timmyThemeModuleAOK,
        appName = "Timtudo",
    );

    companion object Serializer : KSerializer<Brand> {
        override val descriptor: SerialDescriptor =
            PrimitiveSerialDescriptor("Brand", PrimitiveKind.STRING)

        override fun serialize(encoder: Encoder, value: Brand) {
            encoder.encodeString(value.name)
        }

        override fun deserialize(decoder: Decoder): Brand {
            val key = decoder.decodeString()
            return requireNotNull(Brand.entries.find { it.name == key.uppercase() }) {
                "Unknown brand: \"$key\". Valid values: ${Brand.entries.joinToString { it.name }}"
            }
        }
    }
}

